(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trutuff-find-your-match"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.tt-match').forEach(function(section){
    var groups = section.querySelectorAll('.tt-match__group');
    var grid = section.querySelector('.tt-match__grid');
    var stage = section.querySelector('.tt-match__stage');
    var allCards = section.querySelectorAll('.tt-match__card');
    var metaEl = section.querySelector('.tt-match__meta');
    var pagerCurrent = section.querySelector('.tt-match__pager-current');
    var pagerTotal = section.querySelector('.tt-match__pager-total');
    var prevBtn = section.querySelector('.tt-match__nav--prev');
    var nextBtn = section.querySelector('.tt-match__nav--next');
    var total = allCards.length;
    var state = {};
    groups.forEach(function(g){ state[g.dataset.group] = 'all'; });

    var pageIndex = 0; // desktop: index of leftmost visible card (0-based), moves by 1

    function isMobile(){ return window.matchMedia('(max-width:768px)').matches; }

    function visibleCards(){
      return Array.prototype.filter.call(allCards, function(c){ return !c.classList.contains('is-hidden'); });
    }

    function updateFilterVisibility(){
      allCards.forEach(function(card){
        var tags = (card.dataset.tags || '').split(',').map(function(t){return t.trim();});
        var show = true;
        Object.keys(state).forEach(function(groupKey){
          var val = state[groupKey];
          if (val === 'all') return;
          if (tags.indexOf(val) === -1) show = false;
        });
        card.classList.toggle('is-hidden', !show);
      });
    }

    function updateMeta(visibleCount){
      if (!metaEl || total === 0) return;
      if (visibleCount === 0) metaEl.textContent = 'No shoes match. Try a different combination.';
      else if (visibleCount === total) metaEl.textContent = 'Showing all ' + total + ' shoes';
      else metaEl.textContent = 'Showing ' + visibleCount + ' of ' + total + ' shoes';
    }

    function updateDesktopSlide(){
      if (isMobile() || !grid) return;
      var vCards = visibleCards();
      var count = vCards.length;
      if (count === 0) return;
      var maxIndex = Math.max(0, count - 3);
      if (pageIndex > maxIndex) pageIndex = maxIndex;
      if (pageIndex < 0) pageIndex = 0;

      /* Compute offset: each card width = (100 / 3)% of grid minus gap fraction.
         Since cards use flex-basis 33.333%, translateX by pageIndex * (card width + gap) */
      var cardEl = vCards[0];
      if (!cardEl) return;
      var cardWidth = cardEl.getBoundingClientRect().width;
      var gap = 2; // matches CSS gap
      var offset = pageIndex * (cardWidth + gap);
      grid.style.transform = 'translateX(-' + offset + 'px)';

      if (prevBtn) prevBtn.classList.toggle('is-disabled', pageIndex <= 0);
      if (nextBtn) nextBtn.classList.toggle('is-disabled', pageIndex >= maxIndex);

      if (pagerCurrent) pagerCurrent.textContent = (pageIndex + 1) + '-' + Math.min(pageIndex + 3, count);
      if (pagerTotal) pagerTotal.textContent = count;
    }

    function updateMobilePager(){
      var pagerC = section.querySelector('.tt-match__pager-current');
      var pagerT = section.querySelector('.tt-match__pager-total');
      var vCards = visibleCards();
      if (pagerT) pagerT.textContent = vCards.length;
      if (pagerC) pagerC.textContent = vCards.length === 0 ? '0' : '1';
      if (grid) grid.scrollLeft = 0;
    }

    function applyFilters(){
      updateFilterVisibility();
      var vCards = visibleCards();
      updateMeta(vCards.length);
      pageIndex = 0;
      if (isMobile()) updateMobilePager();
      else updateDesktopSlide();
    }

    groups.forEach(function(group){
      var pills = group.querySelectorAll('.tt-match__pill');
      pills.forEach(function(pill){
        pill.addEventListener('click', function(){
          pills.forEach(function(p){ p.classList.remove('is-active'); p.setAttribute('aria-selected','false'); });
          pill.classList.add('is-active');
          pill.setAttribute('aria-selected','true');
          state[group.dataset.group] = pill.dataset.value;
          applyFilters();
        });
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function(){
      pageIndex -= 1;
      updateDesktopSlide();
    });
    if (nextBtn) nextBtn.addEventListener('click', function(){
      pageIndex += 1;
      updateDesktopSlide();
    });

    /* MOBILE PAGER: track which card is centered via IntersectionObserver */
    if (grid && 'IntersectionObserver' in window) {
      var lastActive = 0;
      var io = new IntersectionObserver(function(entries){
        if (!isMobile()) return;
        var best = null;
        entries.forEach(function(e){
          if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
        });
        if (best && best.intersectionRatio > 0.5) {
          var card = best.target;
          if (card.classList.contains('is-hidden')) return;
          var vCards = visibleCards();
          var idx = vCards.indexOf(card);
          var pagerC = section.querySelector('.tt-match__pager-current');
          if (idx > -1 && idx !== lastActive && pagerC) {
            lastActive = idx;
            pagerC.textContent = (idx + 1);
          }
        }
      }, { root: grid, threshold: [0.5, 0.75, 1] });
      allCards.forEach(function(c){ io.observe(c); });
    }

    /* Re-measure on resize (breakpoint change or width change) */
    var resizeTimer;
    window.addEventListener('resize', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function(){
        if (isMobile()) { grid.style.transform = 'none'; updateMobilePager(); }
        else { updateDesktopSlide(); }
      }, 150);
    });

    if (total === 0) {
      if (metaEl) metaEl.textContent = '';
    } else {
      if (isMobile()) updateMobilePager();
      else updateDesktopSlide();
      updateMeta(visibleCards().length);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trutuff-hero"] && !Shopify.designMode) return;
  try {
    
(function() {

  function initHero(sectionId) {
    var section = document.getElementById(sectionId);
    if (!section) return;
    var slidesWrap = section.querySelector('.tt-hero__slides');
    var slides = section.querySelectorAll('.tt-hero__slide');
    var stabs = section.querySelectorAll('.tt-hero__stab');
    var certEl = document.getElementById(sectionId + '-certs');
    var prevBtn = document.getElementById(sectionId + '-prev');
    var nextBtn = document.getElementById(sectionId + '-next');
    var ctaBtn = document.getElementById(sectionId + '-cta-btn');
    var ctaLabel = document.getElementById(sectionId + '-cta-label');
    var isMobile = window.matchMedia('(max-width:768px)').matches;

    if (!isMobile && certEl) {
      var certClone = certEl.cloneNode(true);
      certClone.removeAttribute('id');
      var bodyInner = section.querySelector('.tt-hero__body-inner');
      if (bodyInner) bodyInner.insertBefore(certClone, bodyInner.firstChild);
      certEl.style.display = 'none';
    }

    var currentIdx = 0;
    var slideCount = slides.length;

    function goToSlide(idx) {
      if (idx < 0) idx = slideCount - 1;
      if (idx >= slideCount) idx = 0;
      currentIdx = idx;
      Array.prototype.forEach.call(slides, function(slide, si) {
        slide.classList.toggle('is-active', si === idx);
      });
      Array.prototype.forEach.call(stabs, function(t, ti) {
        t.classList.toggle('is-active', ti === idx);
        t.setAttribute('aria-selected', ti === idx ? 'true' : 'false');
      });
      // no per-slide CTA update needed — button links to collection
    }

    function safeActivate(btn, handler) {
      if (!btn) return;
      btn.addEventListener('click', function(e) {
        handler();
        btn.blur();
        if (document.activeElement === btn) document.activeElement.blur();
      });
      btn.addEventListener('keydown', function(e) {
        if (['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].indexOf(e.key) !== -1) {
          e.preventDefault(); e.stopPropagation();
        }
      });
    }

    safeActivate(prevBtn, function(){ goToSlide(currentIdx - 1); });
    safeActivate(nextBtn, function(){ goToSlide(currentIdx + 1); });

    Array.prototype.forEach.call(stabs, function(stab, idx){
      stab.addEventListener('click', function(){
        var url = slides[idx] ? slides[idx].getAttribute('data-url') : '';
        if (url) { window.location.href = url; return; }
        goToSlide(idx);
        stab.blur();
      });
      stab.addEventListener('keydown', function(e) {
        if (['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].indexOf(e.key) !== -1) {
          e.preventDefault(); e.stopPropagation();
        }
      });
    });

    if (slidesWrap && slideCount > 1) {
      var startX = 0, startY = 0, tracking = false, moved = false;
      function onDown(e){ tracking = true; moved = false; startX = e.clientX; startY = e.clientY; }
      function onMove(e){ if (!tracking) return; var dx = e.clientX - startX; var dy = e.clientY - startY; if (Math.abs(dx) > 8 || Math.abs(dy) > 8) moved = true; }
      function onUp(e){
        if (!tracking) return; tracking = false; if (!moved) return;
        var dx = e.clientX - startX; var dy = e.clientY - startY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          if (dx > 0) goToSlide(currentIdx - 1); else goToSlide(currentIdx + 1);
        }
      }
      if (window.PointerEvent) {
        slidesWrap.addEventListener('pointerdown', onDown);
        slidesWrap.addEventListener('pointermove', onMove);
        slidesWrap.addEventListener('pointerup', onUp);
        slidesWrap.addEventListener('pointercancel', function(){ tracking=false; });
      } else {
        slidesWrap.addEventListener('touchstart', function(e){ var t=e.touches[0]; onDown({clientX:t.clientX,clientY:t.clientY}); }, {passive:true});
        slidesWrap.addEventListener('touchmove', function(e){ var t=e.touches[0]; onMove({clientX:t.clientX,clientY:t.clientY}); }, {passive:true});
        slidesWrap.addEventListener('touchend', function(e){ var t=e.changedTouches[0]; onUp({clientX:t.clientX,clientY:t.clientY}); }, {passive:true});
      }
    }
  }

  if (document.readyState==='loading') {
    document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('.tt-hero').forEach(function(s){initHero(s.id);});});
  } else { document.querySelectorAll('.tt-hero').forEach(function(s){initHero(s.id);}); }
  document.addEventListener('shopify:section:load',function(e){var s=e.target.querySelector('.tt-hero'); if(s) initHero(s.id);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trutuff-shoe-finder-cta"] && !Shopify.designMode) return;
  try {
    
(function(){
  var ease = function(t){ return 1 - Math.pow(1 - t, 4); };
  function parseTarget(raw){
    if (raw == null) return null;
    var s = String(raw).trim();
    var m = s.match(/^([\+\-]?[0-9]+(?:\.[0-9]+)?)(.*)$/);
    if (!m) return null;
    return { num: parseFloat(m[1]), suffix: m[2] || '' };
  }
  function animateNumber(el, target){
    var duration = 1400;
    var start = null;
    var isInt = Number.isInteger(target.num);
    function step(ts){
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      var val = target.num * ease(t);
      var display = isInt ? Math.round(val) : val.toFixed(1);
      el.textContent = display + target.suffix;
      if (t < 1) requestAnimationFrame(step);
      else el.textContent = (isInt ? target.num : target.num.toFixed(1)) + target.suffix;
    }
    requestAnimationFrame(step);
  }
  function initStatsForSection(section){
    var group = section.querySelector('[data-tt-count-group]');
    if (!group) return;
    var valueEls = group.querySelectorAll('[data-tt-count]');
    if (!valueEls.length) return;
    var targets = [];
    valueEls.forEach(function(el){
      var parsed = parseTarget(el.getAttribute('data-tt-count'));
      if (parsed) { targets.push({ el: el, target: parsed }); el.textContent = '0' + parsed.suffix; }
    });
    if (!targets.length) return;
    var played = false;
    function play(){
      if (played) return; played = true;
      targets.forEach(function(item, i){ setTimeout(function(){ animateNumber(item.el, item.target); }, i * 140); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting) { play(); io.disconnect(); } });
      }, { threshold: 0.35 });
      io.observe(group);
    } else play();
  }
  document.querySelectorAll('.tt-shoefinder').forEach(initStatsForSection);
  document.addEventListener('shopify:section:load', function(e){
    var s = e.target.querySelector('.tt-shoefinder');
    if (s) initStatsForSection(s);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
